import * as z from 'zod'

import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsPremiumBikeTheftNeodigitalDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return (
    schemaUtils.bornOnErrorMap(issue, {
      min: 'sharedFlows_contents:steps.contents.new.birthday.errors.errorTooYoung',
      max: 'sharedFlows_contents:steps.contents.new.birthday.errors.errorTooOld',
    }) ?? { message: ctx.defaultError }
  )
}

const contents_birthday = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: z.object({
      born_on: BaseSchema_ContentsPremiumBikeTheftNeodigitalDe.shape.born_on,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.birthday.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    nextStep: 'living_space',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default contents_birthday
